import { render, staticRenderFns } from "./studioDashboardDaycareStatistic.vue?vue&type=template&id=074842de&scoped=true"
import script from "./studioDashboardDaycareStatistic.vue?vue&type=script&lang=js"
export * from "./studioDashboardDaycareStatistic.vue?vue&type=script&lang=js"
import style0 from "./studioDashboardDaycareStatistic.vue?vue&type=style&index=0&id=074842de&prod&lang=scss&scoped=true"
import style1 from "./studioDashboardDaycareStatistic.vue?vue&type=style&index=1&id=074842de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074842de",
  null
  
)

export default component.exports